module.exports = __webpack_public_path__ + "images/goals-1a6bc45540ac9662bce37bad0a9cac5d.png";